
const formatPrice = (nr) => {
  if (typeof nr !== 'number') {
    return nr
  }
  const price = new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' }).format(nr)
  return price
}

export default {
  props: {
    prices: {
      type: Object,
      default: () => ({})
    },
    localPrices: {
      type: Object,
      default: () => ({})
    },
    fromCountry: {
      type: Object,
      default: () => ({})
    },
    toCountry: {
      type: Object,
      default: () => ({})
    },
    paymentType: {
      default: '',
      type: String
    }
  },
  setup () {
    return {
      formatPrice
    }
  }
}
